module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cagefs-plugin/cagefs.component.less
// module id = 1187
// module chunks = 1